export const getServiceAvailablePlaces = (service) => {
  const typeCours = String(service?.typeCours || "");
  const isIndividualService = /individuelle/i.test(typeCours) || !typeCours;

  const rawCandidates = [
    service?.nombrePlaces,
    service?.capaciteMaximale,
    service?.nombrePersonnesMaxAtelier,
    service?.maxParticipants,
  ];

  const availablePlaces = rawCandidates
    .map((value) => Number(value))
    .find((value) => Number.isFinite(value) && value > 0);

  if (availablePlaces && availablePlaces > 0) {
    return availablePlaces;
  }

  if (isIndividualService && (service?.dateService || service?.dateAConvenir)) {
    return 1;
  }

  const backendRemaining = Number(service?.placesRestantes);
  if (Number.isFinite(backendRemaining) && backendRemaining >= 0) {
    return backendRemaining;
  }

  return 0;
};

export const getServiceCapacity = (service) => {
  const typeCours = String(service?.typeCours || "");
  const isIndividualService = /individuelle/i.test(typeCours) || !typeCours;

  const rawCandidates = [
    service?.nombrePlaces,
    service?.capaciteMaximale,
    service?.nombrePersonnesMaxAtelier,
    service?.maxParticipants,
  ];

  const capacity = rawCandidates
    .map((value) => Number(value))
    .find((value) => Number.isFinite(value) && value > 0);

  if (capacity && capacity > 0) {
    return capacity;
  }

  return isIndividualService ? 1 : 0;
};

export const hasUpcomingCreneau = (service) => {
  if (service?.dateAConvenir) return true;

  if (!Array.isArray(service?.dateService) || service.dateService.length === 0) {
    return true;
  }

  const now = new Date();

  return service.dateService.some((rawDate) => {
    if (!rawDate) return false;
    const raw = String(rawDate);
    const hasExplicitTime = raw.includes("T");
    const parsed = new Date(raw);

    if (Number.isNaN(parsed.getTime())) return false;

    if (!hasExplicitTime) {
      parsed.setHours(23, 59, 59, 999);
    }

    return parsed >= now;
  });
};

export const isServicePast = (service) => {
  if (service?.dateAConvenir) return false;
  if (!Array.isArray(service?.dateService) || service.dateService.length === 0) return false;
  return !hasUpcomingCreneau(service);
};

export const matchesPrestationFilter = (service, filterValue) => {
  if (filterValue === "Tous") return true;

  const prestation = String(service?.typePrestation || "").toLowerCase();
  const lieu = String(service?.lieu || "").toLowerCase();
  const ville = String(service?.ville || "").toLowerCase();
  const adresse = String(service?.adresse || "").toLowerCase();
  const locationText = `${lieu} ${ville} ${adresse}`.trim();

  if (filterValue === "Distanciel") {
    return prestation.includes("distanciel") || prestation.includes("en ligne") || lieu.includes("en ligne");
  }

  if (filterValue === "Paris") {
    return locationText.includes("paris");
  }

  if (filterValue === "Genève" || filterValue === "Geneve") {
    return locationText.includes("genève") || locationText.includes("geneve");
  }

  return true;
};